const UserIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 16 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.722 18.5c-3.015 0-5.745-.634-7.722-1.657.006-.453.017-.973.017-1.575 0-1.446 2.335-3.109 4.482-4.334 1.222 1.355 2.712 2.218 3.224 2.218.528 0 2.093-.917 3.335-2.344 2.04 1.236 4.354 2.966 4.354 4.46 0 .603.01 1.124.017 1.581-1.976 1.02-4.699 1.651-7.707 1.651zm0-8.667c-.591 0-3.214-1.677-3.214-4.083S4.763.5 7.722.5c2.96 0 3.215 2.572 3.215 4.978 0 2.405-2.623 4.355-3.215 4.355z"
        fill="currentColor"
      />
    </svg>
  )
}

export default UserIcon
